let cmsLocalUrl: string = "/assets/api/cms";
let cmsApiUrl: string = "";
let cmsApiToken: string = "";

// Anonymous cms forms tier used by the contact page (POST /portal/forms/{schemaId}/submissions).
// Kept separate from cmsApiUrl, which the library shell would read for menu/topbar content.
let formsApiUrl = "https://api-cms.eszes.in";
let contactFormSchemaId = 1;            // "Website contact" on T0001
let snapcartAccessFormSchemaId = 2;     // "Snapcart access request" on T0001
let newsletterFormSchemaId = 3;           // "Newsletter signup" on T0001 (0 would hide the footer form)
let snapcartAccessFormTenantId = "T0001"; // TODO(felix): T0002 once a public T0002 CMS host exists


let apiUrl = "http://localhost:8087";

let documentApiUrl = "https://api-docs.etoscloud.com";
let homepagecmsUrl = "https://esz-saas-mod-document-t0001.s3.ap-south-1.amazonaws.com/public/d95801e0-df41-4367-ad68-67199c790598/content_1770722139861.json"; // HomePage
let aboutuscmsUrl = "https://esz-saas-mod-document-t0001.s3.ap-south-1.amazonaws.com/public/dc5b4d36-7ed2-4613-9583-886d29a4a9dc/content_1771239266406.json";//AboutusPage
let contactcmsUrl = "https://esz-saas-mod-document-t0001.s3.ap-south-1.amazonaws.com/public/ed7f5c1c-60f0-464f-8bcd-35f7ba4b49e7/content_1771239012952.json";//ContactPage
let footercmsUrl = "https://esz-saas-mod-document-t0001.s3.ap-south-1.amazonaws.com/public/1e20d82d-836e-4155-bafa-b01bf40b2942/content_1769691933790.json";//FooterPage
let topbarcmsUrl = "https://esz-saas-mod-document-t0001.s3.ap-south-1.amazonaws.com/public/10f8ff6e-2e86-4ffa-badb-3f8e5bbb3e52/content_1769691848192.json";//TopbarPage
let projectUrl = "https://api-cms.etoscloud.com";


export const environment = {
    production: true,
    languagePlaceholderMappings: {
        index: {
            '{{APP_TITLE}}': "ESZES"
        },
        topBar: {

        },
    },

    aiAutoVoucherUrl: "",

    contentFromLocalAssets: false,

    cmsLocalUrl: cmsLocalUrl,
    cmsApiUrl: cmsApiUrl,
    cmsApiToken: cmsApiToken,
    formsApiUrl: formsApiUrl,
    newsletterFormSchemaId: newsletterFormSchemaId,
    contactFormSchemaId: contactFormSchemaId,
    snapcartAccessFormSchemaId: snapcartAccessFormSchemaId,
    snapcartAccessFormTenantId: snapcartAccessFormTenantId,

    selectedContentLanguage: {
        Code: "en",
        Name: "English",
        Direction: "ltr",
        FontFamily: "Roboto"
    },

    // Available brands for switching (development mode shows all)
    availableBrands: ['etos', 'elifcs', 'airtravel', 'gomakto', 'ledepart', 'appscook', 'blackswan', 'blueleaf', 'centuryhotels', 'cubacle', 'eszescs', 'nct', 'souq', 'tripsnhub'],
    branding: 'eszescs',

    tenantId: "T0001",
    createdNode: 'eszescs',
    primaryNode: 'eszescs',

    apiUrl: apiUrl,
    documentApiUrl: documentApiUrl,
    homepagecmsUrl: homepagecmsUrl,
    aboutuscmsUrl: aboutuscmsUrl,
    contactcmsUrl: contactcmsUrl,
    footercmsUrl: footercmsUrl,
    topbarcmsUrl: topbarcmsUrl,
    projectUrl: projectUrl
};

export let colors = [
    'rgb(255, 205, 86)',
    'rgb(75, 192, 192)',
    'rgb(255, 99, 132)',
    'rgb(54, 162, 235)',
    'rgb(153, 102, 255)',
    'rgb(255, 159, 64)'
];
